"use client";
import React, { useState, useEffect } from "react";
import profileService from "api/profileService";
import { connect } from "react-redux";
import { setUser, setIsLoading } from "stores/mainSlice";
import { LoadSpinner } from "components/LoadSpinner";
import { storeActions } from "stores/storeHelpers";
import { PONERA_UNAUTHENTICATED_ROUTES, PONERA_ROUTES } from "routes";
//import useAuth from '../hooks/useAuth';
import { useTheme } from "@mui/material/styles";

// MUI PRO License Key
import { LicenseInfo } from "@mui/x-license-pro";
LicenseInfo.setLicenseKey(
  "b58e93f2dd77da9179219f673cd95741Tz04NDcwNixFPTE3NDAwNjc5NDQwMDAsUz1wcm8sTE09cGVycGV0dWFsLEtWPTI="
);

const unauthenticatedRoutes = PONERA_UNAUTHENTICATED_ROUTES;

export function LayoutInner(props) {
  //const location = useLocation()
  //const { auth, setAuth } = useAuth();
  const theme = useTheme();

  const [state, setState] = useState({
    authDataLoaded: false,
  });

  const getData = () => {
    if (unauthenticatedRoutes.some((r) => r == props.location.pathname)) {
    } else {
      if (state.authDataLoaded) return;

      //this.props.setIsLoading(true)
      //store.dispatch(setIsLoading(true));
      storeActions.setIsLoading(true);

      profileService
        .getUserInfo()
        .then((resp) => {
          //resp.data.roles = [123,456]
          props.setUser(resp.data);

          setState({
            ...state,
            authDataLoaded: true,
          });
          sessionStorage.setItem("ulg", "1");
        })
        .catch((err) => {
          if (err.response.status == 401) {
            // console.log(window.history);
            window.location.replace(PONERA_ROUTES.LOGIN);
          }
        })
        .finally(() => {
          //store.dispatch(setIsLoading(false));
          //storeActions.setIsLoading(true)
          //this.props.setIsLoading(false)
          storeActions.setIsLoading(false);
        });
    }
  };

  const showChildren =
    unauthenticatedRoutes.some((r) => r == props.location.pathname) ||
    state.authDataLoaded;

  useEffect(() => {
    getData();
  }, [props.location]);

  return (
    <div className={"theme-" + theme.palette.mode}>
      {showChildren && props.children}

      <LoadSpinner active={props.mainStore.isLoading} />
      {props.mainStore.errorMessageVisible && (
        <div className="common-alert" color={"danger"}>
          {props.mainStore.errorMessageText}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    mainStore: state.main,
  };
};

const mapDispatchToProps = { setUser, setIsLoading };

const Layout = connect(mapStateToProps, mapDispatchToProps)(LayoutInner);

export { Layout };
